var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ErrorPage',{attrs:{"code":"404","title":"errors.404_title","message":"errors.404_message"}})
}
var staticRenderFns = []

export { render, staticRenderFns }